import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../common/SEO';
import Layout from '../common/Layout';
import Button from '../components/ui/Button';
import { Eyebrow } from '../components/ui/SectionHead';
import Notice from '../components/ui/Notice';

const NotFound = () => {
  const { t } = useTranslation('cy');
  const meta = t('notfound.meta', { returnObjects: true });

  return (
    <Layout>
      <SEO title={meta.title} description={meta.description} noindex />

      <section className="cy-section" id="error-404-message" style={{ minHeight: 'min(70vh, 560px)', display: 'flex', alignItems: 'center' }}>
        <div className="cy-container cy-cta-band" style={{ textAlign: 'center' }}>
          <Eyebrow>{t('notfound.eyebrow')}</Eyebrow>
          <h1 className="cy-h1">{t('notfound.h1')}</h1>
          <p className="cy-lede" style={{ marginLeft: 'auto', marginRight: 'auto' }}>{t('notfound.body')}</p>
          <div style={{ marginTop: 32 }}>
            <Button to="/">{t('notfound.cta')}</Button>
          </div>
          <p className="cy-fineprint" style={{ marginTop: 24 }}>{t('notfound.services')}</p>
          <div style={{ marginTop: 24, display: 'flex', flexWrap: 'wrap', gap: 16, justifyContent: 'center' }}>
            {t('notfound.links', { returnObjects: true }).map((l) => (
              <Link className="cy-link" key={l.to} to={l.to}>{l.label}</Link>
            ))}
          </div>
        </div>
      </section>

      <section className="cy-section" id="error-404-help" style={{ paddingTop: 0 }}>
        <div className="cy-container cy-cta-band">
          <h2 className="cy-title" style={{ textAlign: 'center' }}>{t('notfound.help.h2')}</h2>
          <p className="cy-lede" style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>{t('notfound.help.body')}</p>
          <div style={{ marginTop: 24, display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link className="cy-link" to="/contact">{t('notfound.help.contact')}</Link>
            <Link className="cy-link" to="/submit-opportunity">{t('notfound.help.submit')}</Link>
          </div>
          <Notice variant="inline" style={{ marginTop: 32 }}>{t('notfound.help.warning')}</Notice>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
